import styled from 'styled-components';
import { rem } from 'polished';

export const TenantPortingItemInfo = styled.div`
  display: flex;
  gap: ${rem('10px')};
  align-items: center;
  svg {
    width: ${rem('18px')};
    height: ${rem('18px')};
  }
  background-color: #f2f2f2;
  padding: ${rem('5px')};
  margin-bottom: ${rem('20px')};
`;

export const TenantPortingItemHeading = styled.div`
  display: flex;
  gap: ${rem('10px')};
  align-items: center;
  img {
    width: ${rem('56px')};
    height: ${rem('56px')};
  }
  margin-bottom: ${rem('20px')};
`;

export const TenantPortingOrderInfo = styled.div`
  display: flex;
  width: 30%;
  justify-content: space-between;
`;

export const TenantPortingOrderItem = styled.div`
  display: flex;
  flex-direction: column;
`;

export const CompletedPurchaseProcessing = styled.div`
  display: flex;
  margin-top: ${rem('24px')};
  margin-bottom: ${rem('24px')};
  > * {
    &:first-of-type {
      margin-right: ${rem('12px')};
    }
    &:last-of-type {
      margin-right: 0;
      margin-bottom: 0;
    }
  }
`;
